import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private http: HttpClient
  ) {
  }

  async downloadPdf(url: string, httpParams?: HttpParams): Promise<void> {
    await this.downloadFile(url, 'application/pdf', httpParams);
  }

  async openPdf(url: string, httpParams?: HttpParams): Promise<void> {
    await this.openFile(url, 'application/pdf', httpParams);
  }

  async downloadFile(url: string, fileType: string, httpParams?: HttpParams): Promise<void> {
    const response = await this.http.get(url, {params: httpParams, responseType: 'blob', observe: 'response'}).toPromise();
    const downloadInstance = document.createElement('a');
    downloadInstance.href = URL.createObjectURL(new Blob([response.body], {type: fileType}));
    downloadInstance.download = response.headers.get('content-disposition').split(';')[2].split('=')[1].replace(/\"/g, '');
    downloadInstance.click();
  }

  async openFile(url: string, fileType: string, httpParams?: HttpParams): Promise<void> {
    const response = await this.http.get(url, {params: httpParams, responseType: 'blob', observe: 'response'}).toPromise();
    const downloadInstance = document.createElement('a');
    downloadInstance.href = URL.createObjectURL(new Blob([response.body], {type: fileType}));
    downloadInstance.target = '_blank';
    downloadInstance.click();
  }

  openUrl(url: string, newTab = true): void {
    const downloadInstance = document.createElement('a');
    downloadInstance.href = url;
    downloadInstance.target = newTab ? '_blank' : '_self';
    downloadInstance.click();
  }
}
